import clsx from 'clsx';
import React from 'react';
import styles from './Footer.module.scss';
const Footer = () => {
  return <div className={clsx(styles.wrap)}>ООО «Вещи.ру», © 2020-2023</div>;
};

export default Footer;
